<template>
  <div class="BasePannel" v-if="useResStore.showDetail">
    <div class="BasePannel-title">
      <span>搜救站信息</span>
      <el-icon @click="useResStore.closeDetail" style="cursor: pointer" size="21"
        ><CircleClose
      /></el-icon>
    </div>

    <div class="BasePannel-content">
      <el-descriptions :column="1" border>
        
        <el-descriptions-item label="搜救站名称">{{
          useResStore.rescumDetail?.name
        }}</el-descriptions-item>
        <el-descriptions-item label="电话">{{
          useResStore.rescumDetail?.phone
        }}</el-descriptions-item>
        <el-descriptions-item label="经度">{{
          useResStore.rescumDetail?.longitude
        }}</el-descriptions-item>
        <el-descriptions-item label="纬度">{{
          useResStore.rescumDetail?.latitude
        }}</el-descriptions-item>
      </el-descriptions>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { ref, watch } from 'vue'
import { CircleClose } from '@element-plus/icons-vue'

import { useRescueStore } from '@/stores/rescue'
const useResStore = useRescueStore()

watch(
  () => useResStore.resumId,
  (newId) => {
    // console.log('当前选中搜救站ID变化:', newId)
    // console.log(useResStore.rescumDetail)
  }
)
</script>

<style lang="scss" scoped>
.BasePannel {
  width: 360px;
  height: auto;
  position: absolute;
  top: calc(40px + 24px);
  right: 16px;

  box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);
  background-color: rgba(256, 256, 256, 0.5); /* 半透明背景 */
  backdrop-filter: blur(10px); /* 应用模糊效果 */
  border-radius: 6px;
  padding: 16px;
  &-title {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 16px;
    position: relative;
    > span {
      color: #000;
      font-weight: bold;
    }
  }

  &-content {
    flex: 1;
    height: calc(100% - 24px + 16px - 16px * 2);
    overflow: hidden;
    overflow-y: auto;

    ::-webkit-scrollbar {
      width: 8px; /* 滚动条宽度 */
      height: 8px; /* 横向滚动条高度 */
    }
    ::-webkit-scrollbar-track {
      background: #f1f1f1; /* 滚动条轨道背景色 */
    }

    ::-webkit-scrollbar-thumb {
      background: #ddd; /* 滚动条滑块背景色 */
      border-radius: 4px; /* 滚动条滑块圆角 */
    }

    ::-webkit-scrollbar-thumb:hover {
      background: #ccc; /* 滚动条滑块悬停背景色 */
    }

    ::-webkit-scrollbar-button {
      display: none; /* 隐藏滚动条按钮 */
    }
    scrollbar-width: thin; /* 设置滚动条宽度为细 */
    scrollbar-color: #ddd #f1f1f1; /* 滚动条滑块和轨道颜色 */
  }
}

:deep(.el-descriptions__cell) {
  font-size: 12px !important;
}
:deep(.is-bordered-label) {
  width: 45%;
}
</style>
